var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcodeSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2467 40.0643L58.163 36.0731C52.8194 33.4347 46.4027 34.3593 42.0213 38.3991C38.0303 42.079 36.447 47.6901 37.9259 52.9134L41.215 64.5302C42.4465 68.8797 39.0207 73.145 34.5079 72.8807C30.1573 72.6259 26.7683 76.5993 27.7063 80.8552L29.6151 89.5168C30.0866 91.6563 31.0801 93.6459 32.5069 95.3084L33.3121 96.2465C37.7796 101.452 45.1598 103.059 51.3872 100.183L51.9267 99.9333C60.0058 96.2016 69.5285 100.384 72.2472 108.857C73.732 113.485 77.3923 117.091 82.0421 118.506L88.5806 120.495C91.1889 121.289 93.9957 121.116 96.4872 120.009C101.664 117.709 104.35 111.942 102.78 106.499L99.4696 95.0272C97.0905 86.782 99.0988 77.8927 104.791 71.4711L109.801 65.82C115.047 59.9025 115.41 51.1128 110.67 44.7827L110.278 44.258C104.948 37.1402 94.8395 35.7289 87.7643 41.1148L84.8978 43.297C80.1869 46.8831 73.5538 46.4492 69.3503 42.2799C68.4419 41.3789 67.3938 40.6308 66.2467 40.0643Z",
    fill: "#EAF6FB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 103.998,
    width: 60,
    height: 43,
    rx: 6,
    transform: "rotate(-90 50 103.998)",
    fill: "#009EDB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 82.998,
    width: 21,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 87.998,
    width: 21,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 92.998,
    width: 21,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 50.998,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7071 60.2909C77.0976 60.6815 77.0976 61.3146 76.7071 61.7052L71.2071 67.2052C70.8166 67.5957 70.1834 67.5957 69.7929 67.2052L67.2929 64.7052C66.9024 64.3146 66.9024 63.6815 67.2929 63.2909C67.6834 62.9004 68.3166 62.9004 68.7071 63.2909L70.5 65.0838L75.2929 60.2909C75.6834 59.9004 76.3166 59.9004 76.7071 60.2909Z",
    fill: "#009EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeSuccess);
export default __webpack_public_path__ + "static/media/qrcode-success.659b26f6a29160f0e736cdc05af6965c.svg";
export { ForwardRef as ReactComponent };